export default __webpack_public_path__ + "static/ernie-260481d1e99a688a1d9db59bb4e6af88.png";